    const callNodeMailer = (name, email, phone_number, details, SignageTypes, recordId) => {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            name,
            email,
            details,
            "phone": phone_number,
            SignageTypes
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        fetch("https://signize-nodemailer.vercel.app/send", requestOptions)
            .then((response) => response.text())
            .then((result) => {
                // // console.log('');
                const resultObject = JSON.parse(result);
                if (resultObject.type == 'success') {
                    updateAirTableRow(recordId);
                } else {
                    // console.log('Error');
                }

            })
            .catch((error) => console.error(error));
    }

    const updateAirTableRow = (recordId) => {
        // Add the "Sent" field to the data object
        const apiKeySec = 'patvWK53gi4S1hwSD.8bdf1651bf5a5a3137e0b368e887a2c59b0528f92adc1a164f6b4cb36fae86ed';
        const dataToUpdate = {
                id:recordId,
                fields:{
                  SentStatus: "Email Sent",
                }
          }

        // Fetch request to update the Airtable row
        fetch(`https://api.airtable.com/v0/appFDCsi77ZZP9hrh/Signize`, {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${apiKeySec}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                records: [dataToUpdate] // Wrap the data in an array under "records"
            })
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(updatedRecords => {
                console.log('');
            })
            .catch(error => {
                console.error('Error updating records:', error);
            });
    };